// extracted by mini-css-extract-plugin
export var copyright = "style-module--copyright--21ba2";
export var footer = "style-module--footer--d5b7f";
export var footerTop = "style-module--footerTop--d0274";
export var footer_adress_group = "style-module--footer_adress_group--e46b7";
export var footer_group = "style-module--footer_group--3218e";
export var footer_linklist = "style-module--footer_linklist--1ab1c";
export var footer_logo = "style-module--footer_logo--4f629";
export var privacy_policy_link = "style-module--privacy_policy_link--ff712";
export var sns = "style-module--sns--1a31f";
export var sns_list = "style-module--sns_list--244b5";